import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'date_to_date_pipe'})
export class DateToDatePipe implements PipeTransform {
  public static transform(date?: Date, shortYear: boolean = false): string {
    if (date === undefined) {
      return '';
    }

    let day: string = `${date.getUTCDate()}`;
    if (day.length === 1) {
      day = `0${day}`;
    }

    let month: string = `${date.getUTCMonth() + 1}`;
    if (month.length === 1) {
      month = `0${month}`;
    }

    let year: string = `${date.getUTCFullYear()}`;
    if (shortYear) {
      year = year.substring(2);
    }

    return `${day}.${month}.${year}`;
  }

  public transform(date: Date, shortYear: boolean = false): string {
    if (date instanceof Date)
      return DateToDatePipe.transform(date, shortYear);
    else if (date === undefined || date === null)
      return '';
    else {
      return DateToDatePipe.transform(new Date(date), shortYear);
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/pipes/pipe-date-to-date.ts